<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>{{ content }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="pink" flat @click="ok">{{ $t('dialog.info.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: [
    'title',
    'content',
    'dialog',
    'closeDialog'
  ],
  methods: {
    ok () {
      this.closeDialog();
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/popup/InfoDialog.vue